import { PublicShell } from '../components/PublicShell';
import { ApprovedHero, ApprovedServices, ApprovedRegion, ApprovedLinks, ApprovedBuilders, ApprovedProof, ApprovedContact } from '../components/ApprovedHomeSections';

export default function Homepage() {
  return <PublicShell home>
    <ApprovedHero />
    <ApprovedServices />
    <ApprovedRegion />
    <ApprovedLinks />
    <ApprovedBuilders />
    <ApprovedProof />
    <ApprovedContact />
  </PublicShell>;
}
